package features.attendance.domain

data class Holiday(
    val id: String,
    val date: String, // Format: YYYY-MM-DD
    val name: String,
    val description: String = ""
)
